import { render, staticRenderFns } from "./AdjustmentDrafts.vue?vue&type=template&id=36cd8ad8"
import script from "./AdjustmentDrafts.vue?vue&type=script&lang=js"
export * from "./AdjustmentDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports